import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Factory } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { authApi, setToken, setUser, formatApiErrorDetail } from "../lib/authApi";

export default function PartnerLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error("Enter email and password.");
      return;
    }
    setLoading(true);
    try {
      const { data } = await authApi.post("/auth/login", { email, password });
      setToken(data.access_token);
      setUser(data.user);
      toast.success(`Welcome back, ${data.user.name}!`);
      navigate(data.user.role === "partner" ? "/partner" : data.user.role === "admin" ? "/admin" : "/portal");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center py-24 px-4" data-testid="partner-login-page">
      <div className="w-full max-w-md p-8 sm:p-10 rounded-xl bg-card border border-border">
        <div className="h-12 w-12 rounded-lg bg-primary/10 border border-primary/20 flex items-center justify-center mb-6">
          <Factory className="h-5 w-5 text-primary" strokeWidth={1.5} />
        </div>
        <h1 className="text-2xl sm:text-3xl font-medium font-heading tracking-tight">Partner Login</h1>
        <p className="mt-2 text-sm text-muted-foreground">Manage your profile, machines and capabilities.</p>
        <form onSubmit={submit} className="mt-8 space-y-5" data-testid="partner-login-form">
          <div className="space-y-2">
            <Label htmlFor="pl-email">Email</Label>
            <Input id="pl-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" data-testid="partner-login-email-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="pl-password">Password</Label>
            <Input id="pl-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" data-testid="partner-login-password-input" />
          </div>
          <Button type="submit" size="lg" disabled={loading} className="w-full rounded-full" data-testid="partner-login-btn">
            {loading ? "Signing in..." : "Sign In"}
          </Button>
        </form>
        <p className="mt-6 text-sm text-muted-foreground text-center">
          Not a partner yet?{" "}
          <Link to="/partner/register" className="text-primary font-medium hover:underline" data-testid="goto-partner-register-link">
            Apply to join the network
          </Link>
        </p>
      </div>
    </div>
  );
}
